export default "__VITE_ASSET__DpX1hHVt__"